// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./hours-container\"></require>\n  <hours-container show-banner.bind=\"true\" if.bind=\"data.productionOrderId > 0\"\n    production-order-id.bind=\"data.productionOrderId\"></hours-container>\n</template>\n";
// Exports
export default code;